import styled, { css } from 'styled-components';

export const Container = styled.div`
    .language-selector {
        display: flex;
        max-width: 160px;
        margin-left: auto;
    }
`;

export const Content = styled.h2`
    &.header-mobile-container {
        display: flex;
        width: 100%;
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: -0.01em;
        text-align: left;
        margin: 0 0 12px 0;
        padding-top: 16px;

        .inner-title {
            span {
                color: ${(props) => props.theme.palette.primaryA1};
                border-bottom: 1px solid ${(props) => props.theme.palette.primaryA1};
            }
        }

        .mobile-header-back-icon {
            position: relative;
            top: 11px;
            margin-right: 12px;
            transform: scale(1.4) rotate(180deg);
            min-width: 17px;
            transition: opacity 0.3s linear;

            &:active {
                opacity: 0.5;
            }
        }

        &.fixed-header {
            position: fixed;
            z-index: 1000;
            color: ${(props) => props.theme.palette.primaryA7};
            top: 16px;

            ${(props) =>
                props.theme.isLandscape &&
                css`
                    ${props.theme.orientation.landscape} {
                        top: 0;
                        color: ${props.theme.palette.primaryA1};
                    }
                `}
        }
    }
`;
